const Glide = window.Glide;
import { centerControlsOnImage, disableIfGlideFit, setButtonsVisibility } from "../../../Scripts/glideControls.js";
const upcomingMarkets = (() => {
  function setUpCarousel() {
    const sliders = document.querySelectorAll(".block__upcomingMarketsWidget .glide");
    const imageHolder = document.querySelector(".block__upcomingMarketsWidget .block__imageHolder");
    const glideControls = document.querySelectorAll(".block__upcomingMarketsWidget .block__glideControls");
    const glides = [];
    const options = {
      perView: 3,
      peek: { before: 0, after: 91 },
      bound: true,
      gap: 24,
      rewind: false,
      breakpoints: {
        649: {
          perView: 1,
          peek: { before: 0, after: 72 },
          gap: 16,
        },
        767: {
          perView: 1,
          peek: { before: 0, after: 200 },
          gap: 16,
        },
        1023: {
          perView: 2,
          peek: { before: 0, after: 132 },
          gap: 17,
        },
        1365: {
          perView: 3,
          gap: 16,
          peek: { before: 0, after: 100 },
        },
      },
    };
  
    sliders.forEach((slider) => {
      let glide = new Glide(slider, options);
      glide.on("move.after", () => {
        let firstButton = glide.selector.querySelector(".button__glide.button__prev");
        let lastButton = glide.selector.querySelector(".button__glide.button__next");
        let numOfSlides = glide.selector.querySelectorAll(".glide__slide").length;
        setButtonsVisibility(glide, firstButton, lastButton, numOfSlides);
      });
      glides.push(glide.mount());
    });
    for (let i = 0; i < glides.length; i++) {
      disableIfGlideFit(glides[i]);
    }
    if(sliders) {
      window.addEventListener("resize", () => {
        for (let i = 0; i < glides.length; i++) {
          disableIfGlideFit(glides[i]);
          centerControlsOnImage(imageHolder, glideControls);
        }
      });
    }
  }

  setUpCarousel();
  return {setUpCarousel : setUpCarousel}
})();

export {upcomingMarkets}
